import React from 'react';
import { Box, Typography } from '@mui/material';
import * as styles from './styles';

const LINKS = [
    { label: 'Privacy', href: 'https://ecal.com/privacy-policy/' },
    { label: 'Terms',   href: 'https://ecal.com/terms-of-use/' },
    { label: 'Cookies', href: 'https://ecal.com/cookie-policy/' },
];

function Legal() {
    return (
        <Box>
            <Typography sx={styles.colTitle}>Legal</Typography>
            <Box component="ul" sx={styles.linkList}>
                {LINKS.map(({ label, href }) => (
                    <li key={href}>
                        <Box
                            component="a"
                            href={href}
                            target="_blank"
                            rel="noreferrer noopener"
                            sx={styles.link}
                        >
                            {label}
                        </Box>
                    </li>
                ))}
            </Box>
        </Box>
    );
}

export default Legal;
